import { createFileRoute, notFound } from "@tanstack/react-router";
import { ClientReport } from "@/components/ClientReport";
import { getReportByToken } from "@/lib/cliente.functions";

export const Route = createFileRoute("/r/$token")({
  head: () => ({
    meta: [
      { title: "Relatório de Landing Pages · Selectus RH" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  loader: async ({ params }) => {
    try {
      return await getReportByToken({ data: { token: params.token } });
    } catch {
      throw notFound();
    }
  },
  errorComponent: () => (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
      <div className="max-w-md rounded-xl border bg-white p-8 text-center shadow-sm">
        <h1 className="font-display text-xl font-bold text-brand-navy">Relatório indisponível</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Este link pode ter sido revogado ou não é válido.
        </p>
      </div>
    </div>
  ),
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 px-4">
      <div className="max-w-md rounded-xl border bg-white p-8 text-center shadow-sm">
        <h1 className="font-display text-xl font-bold text-brand-navy">Link inválido</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Verifique com quem compartilhou o relatório.
        </p>
      </div>
    </div>
  ),
  component: ReportPage,
});

function ReportPage() {
  const { label, rows } = Route.useLoaderData();
  return <ClientReport label={label} rows={rows} />;
}